import type { IconProps } from './../../models/icon';

export function PieChartIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M0.856934 12C0.856934 18.1542 5.84576 23.1429 11.9998 23.1429C15.0768 23.1429 17.8625 21.8958 19.879 19.8792L11.9998 12V0.857178C5.84576 0.857178 0.856934 5.84601 0.856934 12Z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M12 0.857178V12L19.8792 19.8792C21.8957 17.8627 23.1429 15.0771 23.1429 12C23.1429 5.84601 18.1541 0.857178 12 0.857178Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M11.9998 23.1429C18.1539 23.1429 23.1426 18.1541 23.1426 12C23.1426 5.84601 18.1539 0.857178 11.9998 0.857178C5.84576 0.857178 0.856934 5.84601 0.856934 12C0.856934 18.1541 5.84576 23.1429 11.9998 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 0.857178V12L19.8857 19.8858"
        />
      </g>
    </svg>
  );
}
